import { createRouter, createWebHistory } from 'vue-router'
import { nextTick } from 'vue'
import HomeView from '../views/HomeView.vue'

const SITE_URL = 'https://www.haskrediet.be'
const DEFAULT_TITLE = 'HasKrediet - Persoonlijke en professionele leningen sinds 1995'
const DEFAULT_DESCRIPTION =
  'HasKrediet is uw kredietmakelaar in Gent sinds 1995. Woonleningen, leningen op afbetaling, leasing en verzekeringen — persoonlijk advies op maat.'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: DEFAULT_TITLE,
      description: DEFAULT_DESCRIPTION,
    },
  },
  {
    path: '/woonlening',
    name: 'woonlening',
    component: () => import(/* webpackChunkName: "woonlening" */ '../views/WoonleningView.vue'),
    meta: {
      title: 'Woonlening in Gent | HasKrediet',
      description:
        'Een woonlening op maat voor uw huis, appartement of renovatie. HasKrediet vergelijkt en adviseert persoonlijk — al 30 jaar in Gent.',
    },
  },
  {
    path: '/leningen-op-afbetaling',
    name: 'leningen',
    component: () => import(/* webpackChunkName: "leningen" */ '../views/LeningenView.vue'),
    meta: {
      title: 'Lening op afbetaling | HasKrediet Gent',
      description:
        'Geld lenen voor een auto, renovatie of persoonlijke plannen? Bereken uw lening op afbetaling en krijg persoonlijk advies bij HasKrediet in Gent.',
    },
  },
  {
    path: '/leasing',
    name: 'leasing',
    component: () => import(/* webpackChunkName: "leasing" */ '../views/LeasingView.vue'),
    meta: {
      title: 'Leasing | HasKrediet Gent',
      description:
        'Leasing voor zelfstandigen en ondernemingen: bedrijfswagens en bedrijfsmiddelen financieren zonder uw werkkapitaal aan te spreken. Advies bij HasKrediet.',
    },
  },
  {
    path: '/ondernemers',
    name: 'ondernemers',
    component: () => import(/* webpackChunkName: "ondernemers" */ '../views/OndernemersView.vue'),
    meta: {
      title: 'Kredieten voor ondernemers | HasKrediet Gent',
      description:
        'Financiering voor zelfstandigen en KMO’s: investeringskredieten, kaskredieten en meer. HasKrediet begeleidt ondernemers in Gent sinds 1995.',
    },
  },
  {
    path: '/wie-zijn-wij',
    name: 'wieZijnWij',
    component: () => import(/* webpackChunkName: "wie-zijn-wij" */ '../views/WieZijnWijView.vue'),
    meta: {
      title: 'Wie zijn wij? | HasKrediet Gent',
      description:
        'Maak kennis met HasKrediet, uw onafhankelijke kredietmakelaar in Gent sinds 1995. Persoonlijk advies voor particulieren en ondernemers.',
    },
  },
  {
    path: '/verzekeringen',
    name: 'verzekeringen',
    component: () => import(/* webpackChunkName: "verzekeringen" */ '../views/VerzekeringenView.vue'),
    meta: {
      title: 'Verzekeringen | HasKrediet Gent',
      description:
        'Schuldsaldo-, brand- en andere verzekeringen bij uw krediet. HasKrediet adviseert u over de juiste dekking, in samenwerking met o.a. Allianz en AG.',
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
    meta: {
      title: 'Contact | HasKrediet Gent',
      description:
        'Contacteer HasKrediet: Sleepstraat 186 A, 9000 Gent — tel. 09/267.30.30. Open ma-vrij 9.00-12.30 en 13.30-18.00, zaterdagmiddag op afspraak.',
    },
  },
  {
    path: '/juridische-mededeling',
    name: 'juridisch',
    component: () => import(/* webpackChunkName: "juridisch" */ '../views/JuridischView.vue'),
    meta: {
      title: 'Juridische mededelingen | HasKrediet',
      description: 'Juridische informatie en wettelijke vermeldingen van HASKREDIET BV.',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/PrivacyView.vue'),
    meta: {
      title: 'Privacybeleid | HasKrediet',
      description: 'Hoe HASKREDIET BV omgaat met uw persoonsgegevens en privacy.',
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

const setMetaContent = (selector: string, content: string) => {
  const el = document.head.querySelector<HTMLMetaElement>(selector)
  if (el) el.setAttribute('content', content)
}

router.afterEach((to: any) => {
  const title = (to.meta?.title as string) ?? DEFAULT_TITLE
  const description = (to.meta?.description as string) ?? DEFAULT_DESCRIPTION
  const url = SITE_URL + to.path

  document.title = title
  setMetaContent('meta[name="description"]', description)
  setMetaContent('meta[property="og:title"]', title)
  setMetaContent('meta[property="og:description"]', description)
  setMetaContent('meta[property="og:url"]', url)
  const canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]')
  if (canonical) canonical.setAttribute('href', url)

  nextTick(() => {
    if (to.hash) {
      const el = document.querySelector(to.hash)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      window.scrollTo(0, 0)
    }
  })
})

export default router
